import { createContext, FC, ReactNode, useContext } from 'react';

export type TMobileSignupStatus = {
  isSeeded: boolean;
};

const MobileSignupStatusContext = createContext<TMobileSignupStatus | null>(
  null,
);

export const MobileSignupStatusProvider: FC<{
  value: TMobileSignupStatus;
  children: ReactNode;
}> = ({ value, children }) => (
  <MobileSignupStatusContext.Provider value={value}>
    {children}
  </MobileSignupStatusContext.Provider>
);

export const useMobileSignupStatus = (): TMobileSignupStatus => {
  const status = useContext(MobileSignupStatusContext);
  if (!status) {
    throw new Error(
      'useMobileSignupStatus must be used within a MobileSignupStatusProvider',
    );
  }
  return status;
};
